import i18next from 'i18next'

import menuEn from 'views/panels/admin-panel/DeviceGateway/locales/menu.en.json'
import menuTh from 'views/panels/admin-panel/DeviceGateway/locales/menu.th.json'

/**
 * The screen's translation namespace. Its copy ships with the code: the
 * translation rows (`Core.Translation`) live in the database that seeds
 * production, so this screen adds none (Tech Lead decision, 2026-10-13).
 */
export const DEVICE_GATEWAY_NS = 'device-gateway'

/** The menu entry's title, resolved by NavItem's `t()` from this namespace. */
export const DEVICE_GATEWAY_MENU_TITLE_KEY = `${DEVICE_GATEWAY_NS}:menu.title`

/**
 * Only what the menu shows. The menu is in the app's main chunk, so this is
 * all of the namespace every user downloads; the rest of the copy loads with
 * the screen (`deviceGateway.i18n.js`).
 */
export const DEVICE_GATEWAY_MENU_BUNDLES = { en: menuEn, th: menuTh }

/**
 * Adds bundles to the namespace, merged into what it already holds.
 * `src/i18n.js` initialises this same i18next instance, but `src/index.js`
 * imports it after the App tree, so the menu loads this module first — and
 * before `init()` the store methods do not exist, so registration waits.
 *
 * Registering adds the namespace to the ones i18next loads on a language
 * change. Users on a language other than th/en therefore make 1–2 tiny
 * requests per page load for it (`device-gateway/<language>.json`), which core
 * answers with `{}`; th/en users make none.
 */
export const registerDeviceGatewayBundles = (bundles, i18n = i18next) => {
  const register = () =>
    Object.entries(bundles).forEach(([language, bundle]) => {
      i18n.addResourceBundle(language, DEVICE_GATEWAY_NS, bundle, true, false)
    })
  if (typeof i18n.addResourceBundle === 'function') register()
  else i18n.on('initialized', register)
}

registerDeviceGatewayBundles(DEVICE_GATEWAY_MENU_BUNDLES)
